<form novalidate [formGroup]="attributeFacetsForm">
  <ng-container *ngFor="let attribute of isBrandPLPPage ? getAttributes() : _attributes">
    <ng-container
      *ngIf="(attribute?.options || attribute?.optionsRange)
      && !(attribute?.options?.length === 1 && attribute?.options[0]?.value === 'int_rbg')">
      <mm-expansion
        class="catalog-filter__wrapper__expansion"
        [mmTestId]="'FILTERS.' + attribute.id.toLocaleUpperCase()"
        (toggled)="updateFilterCollapseState(attribute.id, $event)"
        [expanded]="isSpecificAttribute ? true : isFilterCollapseExpanded(attribute.id)"
        [arrowToggler]="true"
        [disableToggle]="isSpecificAttribute"
        [testTarget]="'FILTERS.EXPANSION.TOGGLER'"
      >
        <mm-expansion-title>
          <h4 class="attributes__title">
            {{ attribute?.name }}
            <ng-container *ngIf="attribute?.unit
            && attribute?.options
            && attribute?.options?.length > 0">, {{ attribute?.unit }}</ng-container>
          </h4>
        </mm-expansion-title>

        <div>
          <ul class="attribute-facets" [ngClass]="{'new-design': isMobileOrTablet}">
            <ng-container *ngIf="attribute?.options && attribute?.options.length > 0">
              <ng-container
                *ngFor="
                  let attributeOption of attribute?.options | slice: 0:attributeExpandMap[attribute?.id];
                  let i = index
                "
              >
                <app-search-filter-item *ngIf="attributeOption?.id !== 'int_rbg'"
                                        [ngClass]="{ 'filter__facet-container': isMobileOrTablet }"
                                        [attr.id]="attribute?.id + '--' + attributeOption?.value"
                                        [extended]="getExtendedState(attributeOption)"
                                        [count]="attributeOption?.totalCount"
                                        [hideCount]="isMobileOrTablet">
                  <ng-container *ngIf="!isMobileOrTablet; else filtersFacetsCheckboxes">
                    <mm-checkbox
                      [formControlName]="attribute?.id + '--' + attributeOption?.value"
                      [mmTestTarget]="'attribute-filter'"
                      labelType="short"
                      (change)="onLayerSelected(attribute, attributeOption)"
                    >
                    <span
                      *ngIf="attribute.id === 'color' && !!attributeOption.code"
                      class="color__icon"
                      [ngClass]="'filter__color-' + attributeOption.code"
                    ></span>
                      <span>{{ attributeOption?.name }}</span>
                    </mm-checkbox>
                  </ng-container>
                  <ng-template #filtersFacetsCheckboxes>
                    <label class="filter__facet" [ngClass]="{'selected': isAttributeOptionSelected(attribute?.id,
                    attributeOption?.value) }">
                      <input type="checkbox" class="filter__facet-checkbox"
                             [formControlName]="attribute?.id + '--' + attributeOption?.value"
                             (change)="onLayerSelected(attribute, attributeOption)">
                      <span>{{ attributeOption?.name }}</span>
                      <mm-icon *ngIf="isAttributeOptionSelected(attribute?.id, attributeOption?.value)"
                               class="filter-facets__clearicon" name="close_grey"></mm-icon>
                    </label>
                  </ng-template>
                </app-search-filter-item>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="attribute?.id && attribute?.optionsRange && attribute?.options?.length === 0">
              <app-search-range-filter class="range__filter"
                                       [filterTypes]="attribute?.id"
                                       [attributeName]="attribute?.name"
                                       (rangeFilterChanged)="filterByRange($event)">
              </app-search-range-filter>
            </ng-container>
          </ul>
          <span
            *ngIf="attribute?.options?.length > limitOption"
            class="truncation-button"
            (click)="toggleExpand(attribute?.id, attribute?.options?.length)"
          >
              {{
            attributeExpandMap[attribute?.id] > limitOption
              ? ('SHARED.SHOW_LESS.LABEL' | translate)
              : ('FILTERS.CATEGORIES_LIST.LINK.TEXT.SHOW_MORE' | translate)
            }}
            </span>
        </div>

        <button
          *ngIf="isResetButtonShown(attribute.id)"
          mm-button
          color="secondary"
          class="attribute-reset"
          [fluid]="true"
          [size]="'small'"
          [mmTestTarget]="'reset-by-filter'"
          (click)="reset(attribute)"
        >
          {{ 'CATALOG.CATALOG_PAGE.FILTERS.RESET' | translate }}
        </button>
      </mm-expansion>
      <div *ngIf="!isSpecificAttribute" class="catalog-filter__wrapper-separator"
           [ngClass]="{
          'expanded': isFilterCollapseExpanded(attribute.id)
        }">
      </div>
    </ng-container>
  </ng-container>
</form>
